import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

export default function FrameworkTabs({ items }) {
  const [active, setActive] = useState(0);
  const current = items[active];
  return (
    <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-stretch">
      <div className="lg:col-span-5 space-y-2">
        {items.map((f, i) => (
          <button
            key={f.structure}
            type="button"
            onClick={() => setActive(i)}
            data-testid={`framework-tab-${i}`}
            className={`group relative w-full text-left px-6 lg:px-7 py-5 lg:py-6 transition-all duration-500 border-l-2 ${
              active === i
                ? "border-unik-gold bg-white shadow-[0_4px_24px_rgba(20,53,90,0.06)]"
                : "border-transparent bg-white/40 hover:bg-white hover:border-[#14355a]/30"
            }`}
          >
            <div className="flex items-center gap-4">
              <div
                className={`text-[10.5px] uppercase tracking-[0.22em] font-medium transition-colors duration-300 ${
                  active === i ? "text-unik-gold" : "text-[#14355a]/55"
                }`}
              >
                Stage 0{i + 1}
              </div>
              <div className={`flex-1 h-px transition-all duration-500 ${active === i ? "bg-unik-gold/50" : "bg-[#14355a]/15"}`} />
              <ChevronRight
                size={16}
                className={`transition-all duration-500 ${active === i ? "text-unik-gold translate-x-0.5" : "text-[#14355a]/30 group-hover:translate-x-0.5"}`}
              />
            </div>
            <div className="mt-4 flex items-end justify-between gap-3">
              <h3 className="font-display text-[#14355a] tracking-tight" style={{ fontSize: "clamp(1.375rem, 1.9vw, 1.75rem)", fontWeight: 500, lineHeight: 1.15 }}>
                {f.structure}
              </h3>
              <span className="text-[12px] text-[#14355a]/55 font-display whitespace-nowrap">
                {f.stage}
              </span>
            </div>
          </button>
        ))}
      </div>

      <div className="lg:col-span-7">
        <div key={active} className="relative h-full min-h-[420px] bg-white border border-[#14355a]/10 p-10 lg:p-14 overflow-hidden fade-in" data-testid="framework-detail">
          <div
            className="absolute -top-4 right-6 font-display text-[#14355a]/[0.05] pointer-events-none select-none"
            style={{ fontSize: "clamp(180px, 24vw, 320px)", lineHeight: 1, fontWeight: 500, letterSpacing: "-0.04em" }}
          >
            0{active + 1}
          </div>

          <div className="relative">
            <div className="flex items-center gap-3">
              <span className="w-10 h-px bg-unik-gold" />
              <div className="eyebrow text-unik-gold">{current.stage}</div>
            </div>
            <h3 className="mt-7 font-display text-[#14355a] tracking-tight" style={{ fontSize: "clamp(2rem, 3.4vw, 3.25rem)", fontWeight: 500, lineHeight: 1.05 }}>
              {current.structure}
            </h3>

            <div className="mt-8">
              <div className="text-[12px] lg:text-[13px] uppercase tracking-[0.22em] text-[#14355a]/65 font-medium">What it does</div>
              <p className="mt-4 text-[17px] lg:text-[19px] leading-[1.85] text-unik-ink/90 max-w-2xl">{current.whatItDoes}</p>
            </div>

            <div className="mt-7 pt-7 border-t border-[#14355a]/15">
              <div className="text-[12px] lg:text-[13px] uppercase tracking-[0.22em] text-unik-gold font-medium">Where we apply it</div>
              <p className="mt-4 text-[17px] lg:text-[19px] leading-[1.85] text-unik-ink/90 max-w-2xl">{current.whereWeApply}</p>
            </div>

            <div className="mt-12 flex items-center gap-2">
              {items.map((_, i) => (
                <button
                  key={items[i].structure}
                  type="button"
                  onClick={() => setActive(i)}
                  aria-label={`Show stage ${i + 1}`}
                  className={`h-[2px] transition-all duration-500 ${active === i ? "w-12 bg-unik-gold" : "w-6 bg-[#14355a]/20 hover:bg-[#14355a]/40"}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
